import moment from "moment";

export const formatPublishDate = (publishedAt, isVisible) => {
  var publishedInFuture = publishedAt * 1000 > new Date().valueOf();
  var formattedDate = moment(publishedAt, "X").format("MMMM D, YYYY [at] h:mm a");
  if (!isVisible) {
    return `Unpublished Draft`;
  }
  if (publishedInFuture) {
    return `Draft, To Publish on ${formattedDate}`;
  }
  return `Published on ${formattedDate}`;
};
